import type * as THREE from 'three';
import type { IViewPortOrientation } from '../interfaces';

export class ViewPortOrientation implements IViewPortOrientation {
  public topVector: THREE.Vector3;

  public directionVector: THREE.Vector3;

  public constructor(top: THREE.Vector3, direction: THREE.Vector3) {
    this.topVector = top;
    this.directionVector = direction;
  }
}
